import {useContext} from "react";
import {AgoraContext} from '../context/AgoraContext';

export const useAgoraClient = () => {
    const {rtc} = useContext(AgoraContext);
    return rtc;
}
